module.exports = __webpack_public_path__ + "img/jylnicon6.93a95981.jpg";